import * as ramda from 'ramda';

import type {EmailSequenceTemplateTemplate} from 'nutshell-graphql-types';

import type {EmailTemplate} from '../types';

/**
 * Get the id of the first email template in an email sequence template by
 * position
 *
 * @param emailSequenceTemplate The email sequence template to find the first
 * email template for
 * @returns The id the first template in the email sequence template
 */
export function getFirstEmailTemplateId(
    emailSequenceTemplate: EmailSequenceTemplateTemplate & {
        emailSequenceTemplateMessages: {
            [templateId: string]: EmailTemplate;
        };
    }
): string {
    return (
        ramda
            .values(emailSequenceTemplate.emailSequenceTemplateMessages)
            // @ts-expect-error
            .reduce((lowestPositionTemplate: EmailTemplate, currentTemplate: EmailTemplate) => {
                return currentTemplate.position < lowestPositionTemplate.position
                    ? currentTemplate
                    : lowestPositionTemplate;
                // @ts-expect-error
            }, ramda.values(emailSequenceTemplate.emailSequenceTemplateMessages)[0]).id
    );
}
